import React from "react";
import DashboardBarChart from "../../common/DashboardBarChart";

const FeatureCategoriesAnalysis = ({ data, loading }) => {
  if (loading) {
    return (
      <div className="flex items-center justify-center h-[500px]">
        <div className="animate-spin h-8 w-8 border-b-2 border-teal-700 rounded-full"></div>
        <span className="ml-2">Loading feature categories...</span>
      </div>
    );
  }

  // Top 10 categories by cost
  const items = (data?.costByFeatureCategory || []).slice(0, 10).map((item) => ({
    name: item.categoryName || "Unknown",
    count: item.totalCost || 0,
  }));

  return (
    <div className="bg-white">
      <DashboardBarChart items={items} unit="total cost" />
    </div>
  );
};

export default FeatureCategoriesAnalysis;
